import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const CategoryApi = createApi({
  reducerPath: "CategoryApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["CATEGORYAPI"],
  endpoints: (build) => ({
    getCategory: build.query({
      query: ({ page, searchTerm }) => ({
        url: `/faqs-category?page=${page}&search=${searchTerm}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CATEGORYAPI"],
    }),

    getCategoryById: build.query({
      query: ({ id }) => ({
        url: `/faqs-category/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CATEGORYAPI"],
    }),

    editCategory: build.mutation({
      query: ({ id, data }) => ({
        url: `/faqs-category/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["CATEGORYAPI"],
    }),

    addCategory: build.mutation({
      query: ({ data }) => ({
        url: `/faqs-category`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["CATEGORYAPI"],
    }),

    deleteCategory: build.mutation({
      query: ({ id }) => ({
        url: `/faqs-category/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CATEGORYAPI"],
    }),
  }),
});

export const {
  useGetCategoryQuery,
  useGetCategoryByIdQuery,
  useEditCategoryMutation,
  useAddCategoryMutation,
  useDeleteCategoryMutation,
} = CategoryApi;
